import EditIcon from '@mui/icons-material/Edit';
import { Container, Typography, Grid, Box } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'
import { userState } from 'src/store/user/userState'
import useSavePatient from '../hooks/useSavePatient'
import FormCompleteInformation from '../register/components/FormCompleteInformation'
import { valuesFormRegisterState } from '../state/atoms'
import useSEO from 'src/Hooks/useSEO';

const Index = () => {
    const user = useRecoilValue(userState);
    const setValuesFormRegister = useSetRecoilState(valuesFormRegisterState);
    const valuesFormRegister = useRecoilValue(valuesFormRegisterState);
    const resetValuesFormRegister = useResetRecoilState(valuesFormRegisterState);
    const { handleClickEditPatient, loading } = useSavePatient()

    useSEO({title: 'Datos personales'});

    useEffect(() => {
        if(user.payload) {
            setValuesFormRegister({
                ...valuesFormRegister,
                ...user.payload,
                fechaNac: user.payload.fechaNac ? user.payload.fechaNac?.split(" ")[0].split("-").reverse().join("-") : null
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    useEffect(() => {
        return () => {
            resetValuesFormRegister()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container style={{ maxWidth: 703 }}>
            <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
                MODIFIQUE SUS DATOS PERSONALES
            </Typography>
            <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
                INGRESE SUS DATOS
            </Typography>
            <FormCompleteInformation />

            <Grid container display={"flex"} justifyContent={"flex-end"} p={2} pr={0}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="MODIFICAR DATOS"
                        icon={<EditIcon />}
                        onClick={handleClickEditPatient}
                    />
                </Box>

            </Grid>

        </Container>
    )
}

export default Index
